import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      if (u.role === "driver") nav("/surucu");
      else if (u.role === "admin") nav("/admin");
      else if (u.role === "business_owner") nav("/panel");
      else nav("/");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-10">
      <div className="rounded-3xl border border-border bg-card p-6">
        <h1 className="text-2xl font-bold tracking-tight mb-1">Giriş Yap</h1>
        <p className="text-sm text-muted-foreground mb-5">Hesabınıza giriş yapın.</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="email">E-posta</Label>
            <Input data-testid="login-email" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11 rounded-xl" required />
          </div>
          <div>
            <Label htmlFor="password">Şifre</Label>
            <Input data-testid="login-password" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-11 rounded-xl" required />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-11 rounded-full press">
            {loading ? "Yükleniyor..." : "Giriş Yap"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-4 text-center">
          Hesabınız yok mu? <Link to="/kayit" className="text-primary font-medium underline">Üye Olun</Link>
        </p>
      </div>
    </div>
  );
}
